var map = {
	"./duca.png": "2e39",
	"./milanesi/2c.png": "4d28",
	"./milanesi/2d.png": "8546",
	"./milanesi/2h.png": "ad6b",
	"./milanesi/2s.png": "3bda",
	"./milanesi/3c.png": "3c09",
	"./milanesi/3d.png": "ee8b",
	"./milanesi/3h.png": "851c",
	"./milanesi/3s.png": "7c20",
	"./milanesi/4c.png": "bac0",
	"./milanesi/4d.png": "e197",
	"./milanesi/4h.png": "39f5",
	"./milanesi/4s.png": "1af9",
	"./milanesi/5c.png": "2dff",
	"./milanesi/5d.png": "5c30",
	"./milanesi/5h.png": "8b60",
	"./milanesi/5s.png": "69e6",
	"./milanesi/6c.png": "ba3f",
	"./milanesi/6d.png": "5002",
	"./milanesi/6h.png": "3cf3",
	"./milanesi/6s.png": "0283",
	"./milanesi/7c.png": "a3c6",
	"./milanesi/7d.png": "18a2",
	"./milanesi/7h.png": "618d",
	"./milanesi/7s.png": "3dac",
	"./milanesi/Ac.png": "e52d",
	"./milanesi/Ah.png": "d07c",
	"./milanesi/As.png": "2692",
	"./milanesi/Jc.png": "390c",
	"./milanesi/Jd.png": "dc2c",
	"./milanesi/Jh.png": "5bd7",
	"./milanesi/Js.png": "c391",
	"./milanesi/Kc.png": "759f",
	"./milanesi/Kd.png": "d198",
	"./milanesi/Kh.png": "a59d",
	"./milanesi/Ks.png": "78b4",
	"./milanesi/Qc.png": "27e5",
	"./milanesi/Qd.png": "14ba",
	"./milanesi/Qh.png": "b182",
	"./milanesi/Qs.png": "5dd8",
	"./milanesi/acediamonds.png": "4d41",
	"./milanesi/duca.png": "8c8a",
	"./milanesi/small/2c.png": "b7f0",
	"./milanesi/small/2d.png": "77c9",
	"./milanesi/small/2h.png": "808c",
	"./milanesi/small/2s.png": "0d87",
	"./milanesi/small/3c.png": "8985",
	"./milanesi/small/3d.png": "8991",
	"./milanesi/small/3h.png": "6831",
	"./milanesi/small/3s.png": "76a5",
	"./milanesi/small/4c.png": "28a5",
	"./milanesi/small/4d.png": "e11a",
	"./milanesi/small/4h.png": "6ad0",
	"./milanesi/small/4s.png": "cb04",
	"./milanesi/small/5c.png": "379c",
	"./milanesi/small/5d.png": "3a4f",
	"./milanesi/small/5h.png": "a11b",
	"./milanesi/small/5s.png": "bc83",
	"./milanesi/small/6c.png": "3113",
	"./milanesi/small/6d.png": "b078",
	"./milanesi/small/6h.png": "d73a",
	"./milanesi/small/6s.png": "8602",
	"./milanesi/small/7c.png": "7760",
	"./milanesi/small/7d.png": "6e22",
	"./milanesi/small/7h.png": "b150",
	"./milanesi/small/7s.png": "e0d0",
	"./milanesi/small/Ac.png": "3bf3",
	"./milanesi/small/Ah.png": "525b",
	"./milanesi/small/As.png": "f51b",
	"./milanesi/small/Jc.png": "988a",
	"./milanesi/small/Jd.png": "c335",
	"./milanesi/small/Jh.png": "09ad",
	"./milanesi/small/Js.png": "662a",
	"./milanesi/small/Kc.png": "3579",
	"./milanesi/small/Kd.png": "679f",
	"./milanesi/small/Kh.png": "981b",
	"./milanesi/small/Ks.png": "838c",
	"./milanesi/small/Qc.png": "11d0",
	"./milanesi/small/Qd.png": "c4e3",
	"./milanesi/small/Qh.png": "aa2f",
	"./milanesi/small/Qs.png": "b1a1",
	"./milanesi/small/acediamonds.png": "0798",
	"./napoletane/2c.png": "04bb",
	"./napoletane/2d.png": "2875",
	"./napoletane/2h.png": "be95",
	"./napoletane/2s.png": "800d",
	"./napoletane/3c.png": "8a72",
	"./napoletane/3d.png": "9e24",
	"./napoletane/3h.png": "d692",
	"./napoletane/3s.png": "3d79",
	"./napoletane/4c.png": "708d",
	"./napoletane/4d.png": "1b29",
	"./napoletane/4h.png": "df77",
	"./napoletane/4s.png": "01dc",
	"./napoletane/5c.png": "e796",
	"./napoletane/5d.png": "31a7",
	"./napoletane/5h.png": "5274",
	"./napoletane/5s.png": "5af2",
	"./napoletane/6c.png": "644c",
	"./napoletane/6d.png": "8af2",
	"./napoletane/6h.png": "742f",
	"./napoletane/6s.png": "7066",
	"./napoletane/7c.png": "3d4c",
	"./napoletane/7d.png": "62b6",
	"./napoletane/7h.png": "0e1c",
	"./napoletane/7s.png": "e952",
	"./napoletane/Ac.png": "43fd",
	"./napoletane/Ah.png": "0141",
	"./napoletane/As.png": "bfc2",
	"./napoletane/Jc.png": "4c8a",
	"./napoletane/Jd.png": "6351",
	"./napoletane/Jh.png": "2d64",
	"./napoletane/Js.png": "c650",
	"./napoletane/Kc.png": "5d46",
	"./napoletane/Kd.png": "82b6",
	"./napoletane/Kh.png": "f1a9",
	"./napoletane/Ks.png": "2ec5",
	"./napoletane/Qc.png": "9caa",
	"./napoletane/Qd.png": "ffb9",
	"./napoletane/Qh.png": "e6d7",
	"./napoletane/Qs.png": "ff75",
	"./napoletane/acediamonds.png": "9110",
	"./napoletane/duca.png": "545a",
	"./piacentine/2c.png": "447b",
	"./piacentine/2d.png": "fbf6",
	"./piacentine/2h.png": "e78f",
	"./piacentine/2s.png": "18db",
	"./piacentine/3c.png": "428b",
	"./piacentine/3d.png": "7ce0",
	"./piacentine/3h.png": "0e73",
	"./piacentine/3s.png": "58a9",
	"./piacentine/4c.png": "d9a6",
	"./piacentine/4d.png": "a865",
	"./piacentine/4h.png": "9340",
	"./piacentine/4s.png": "3280",
	"./piacentine/5c.png": "8e49",
	"./piacentine/5d.png": "7688",
	"./piacentine/5h.png": "0b8c",
	"./piacentine/5s.png": "f0c7",
	"./piacentine/6c.png": "3b92",
	"./piacentine/6d.png": "2334",
	"./piacentine/6h.png": "979a",
	"./piacentine/6s.png": "0159",
	"./piacentine/7c.png": "581d",
	"./piacentine/7d.png": "6c4a",
	"./piacentine/7h.png": "07cd",
	"./piacentine/7s.png": "7394",
	"./piacentine/Ac.png": "9e05",
	"./piacentine/Ah.png": "3215",
	"./piacentine/As.png": "3898",
	"./piacentine/Jc.png": "aa27",
	"./piacentine/Jd.png": "df11",
	"./piacentine/Jh.png": "479a",
	"./piacentine/Js.png": "3f40",
	"./piacentine/Kc.png": "b5ef",
	"./piacentine/Kd.png": "f0cb",
	"./piacentine/Kh.png": "414a",
	"./piacentine/Ks.png": "7e35",
	"./piacentine/Qc.png": "07a4",
	"./piacentine/Qd.png": "191f",
	"./piacentine/Qh.png": "c2d4",
	"./piacentine/Qs.png": "ed95",
	"./piacentine/acediamonds.png": "b7b5",
	"./piacentine/duca.png": "0ec7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6501";